/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/BackButton" />
import React = require("react");
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { NavigationActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/NavigationActionsCreator";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";

export class CancelButton  extends VssComponent {
    public render(): JSX.Element {
        return <NavigateBackButton text={Resources.Cancel} onClick={n => n.closePanel()}/>;
    }
}

export class BackButton  extends VssComponent {
    public render(): JSX.Element {
        return <NavigateBackButton text={Resources.BackButtonText} onClick={n => n.navigateBack()}/>;
    }
}

interface INavigateBackButtonProps {
    text: string;
    onClick: (navigationActionCreator: NavigationActionsCreator) => void;
}

class NavigateBackButton extends VssComponent<INavigateBackButtonProps> {

    private readonly _navigationActionCreator: NavigationActionsCreator;

    constructor(props: INavigateBackButtonProps, context: IVssComponentContext) {
        super(props, context);

        this._navigationActionCreator = ActionCreatorManager.GetActionCreator<NavigationActionsCreator>(NavigationActionsCreator, ActionsCreatorInstanceIds.NavigationActionsCreatorInstanceId);
    }

    public render(): JSX.Element {
        return (<Button
            className="back-button"
            text={this.props.text}
            onClick={this._navigateBack} />);
    }

    private _navigateBack = (): void => {
        this.props.onClick(this._navigationActionCreator);
    }
}
